import { useStore } from 'effector-react';
import Scrollbars from 'react-custom-scrollbars';
import { $seatsSelected } from './seatsStores';
import { SelectedItem } from './SeatItems';

export function SeatsSelected() {
  const selected = useStore($seatsSelected);
  return (
    <div className="flex min-w-0 flex-1 flex-col border-l pl-20">
      <div className="mb-10 text-black-gray">{`已选: ${selected.length}个`}</div>
      {selected.length ? (
        <div className="flex-1">
          <Scrollbars>
            {selected.map((x) => (
              <SelectedItem key={x.id} data={x} />
            ))}
          </Scrollbars>
        </div>
      ) : (
        <div className="text-black-gray">
          未选择时仅企业所有者和作品归属人可以查看
        </div>
      )}
    </div>
  );
}

export default SeatsSelected;
